"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTableRowStyles = exports.useTableRowHeaderStyles = exports.useTableRowBodyStyles = exports.useTableCellStyles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useTableRowStyles = (0, _styles.makeStyles)(function (theme) {
  var _root;

  var dividerProps = {
    display: function display(props) {
      return props.dividers ? 'block' : undefined;
    },
    opacity: function opacity(props) {
      return props.dividers ? 1 : 0;
    }
  };
  return {
    root: (_root = {
      transition: 'background 0.2s'
    }, (0, _defineProperty2.default)(_root, ['&:before', '&.Mui-expanded:before'], _objectSpread({}, dividerProps)), (0, _defineProperty2.default)(_root, '&:nth-child(even):not(.Mui-expanded)', {
      backgroundColor: function backgroundColor(props) {
        return props.zebra ? theme.palette.neutral.iceberg : 'inherit';
      }
    }), (0, _defineProperty2.default)(_root, ['&:first-child:before', '&.Mui-expanded + &:before'], _objectSpread({}, dividerProps)), (0, _defineProperty2.default)(_root, '&$expanded', {
      margin: 0
    }), _root),
    expanded: {
      backgroundColor: theme.palette.denim[50],
      '&:before': _objectSpread({}, dividerProps)
    }
  };
}, {
  name: 'pds-table-mobile__row'
});
exports.useTableRowStyles = useTableRowStyles;
var useTableRowHeaderStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      minHeight: 72,
      overflow: 'hidden',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      '&$expanded': {
        minHeight: 72
      }
    },
    content: {
      '&.Mui-expanded': {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2)
      }
    },
    expanded: {},
    expandIcon: {
      color: theme.palette.denim[500],
      marginRight: theme.spacing(-2)
    }
  };
}, {
  name: 'pds-table-mobile__row-header'
});
exports.useTableRowHeaderStyles = useTableRowHeaderStyles;
var useTableRowBodyStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'block',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(6)
    }
  };
}, {
  name: 'pds-table-mobile__row-body'
});
exports.useTableRowBodyStyles = useTableRowBodyStyles;
var useTableCellStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    label: {
      color: theme.palette.neutral.narwhal,
      fontSize: theme.typography.micro.fontSize,
      lineHeight: theme.typography.micro.lineHeight
    },
    content: {
      color: theme.palette.denim[500],
      fontSize: theme.typography.body.fontSize,
      lineHeight: theme.typography.body.lineHeight
    }
  };
}, {
  name: 'pds-table-mobile__cell'
});
exports.useTableCellStyles = useTableCellStyles;
